export default __webpack_public_path__ + "static/media/lady.35149171.png";